__turbopack_context__.v({
  "root": "AccessCell-module__01ShyW__root",
});
